// Angular
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

// NGRX
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

// OLCI
import { constants, SKIP_ERROR_URL_PATTERNS } from '../constants';
import { LoaderService } from '../modules/loading/loader.service';
import { ErrorService } from '../modules/core/services/error.service';
import { GatingServices } from '../modules/core/services/gating.services';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private readonly HTTP_ERROR_CODES = constants.HTTP_STATUS_CODE;

  // We shouldn't be using the loader at this level. It should be used in the component handling the error
  constructor(
    private readonly errorService: ErrorService,
    private readonly loader: LoaderService,
    private readonly gatingService: GatingServices
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipErrorHandling = SKIP_ERROR_URL_PATTERNS.some(pattern => req.url.includes(pattern));
    return next.handle(req).pipe(
      tap({
        error: (error) => {
          if (!skipErrorHandling) {
            this.hasNotExpiredToken(error);
            this.handleError(error);
          }
        },
      })
    );
  }

  private hasNotExpiredToken(error: any): void {
    if (
      error instanceof HttpErrorResponse &&
      error.status === this.HTTP_ERROR_CODES.UNAUTHORIZED_ERROR
    ) {
      window.location.href = this.gatingService.getGAAccountURL();
    }
  }

  private handleError(error: any): void {
    const { BAD_REQUEST, UNAUTHORIZED_ERROR, UNKNOWN_ERROR } =
      this.HTTP_ERROR_CODES;
    if (
      error instanceof HttpErrorResponse &&
      error.status !== UNAUTHORIZED_ERROR &&
      error.status >= BAD_REQUEST &&
      error.status < UNKNOWN_ERROR
    ) {
      this.loader.hideLoader();
      this.errorService.setResponseError(error);
    }
  }
}
